import React, { useRef, useEffect } from "react";
import "./LenderInterestPopup.scss";
import logo from "../../../assets/images/logo.svg";
import girlImg from "../../../assets/images/img-pp.png";

export const LenderInterestPopup = ({ 
  open, 
  setOpen, 
  userName, 
  onViewDetails 
}) => {
  const popupRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    if (open) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [open, setOpen]);

  const handleViewDetails = () => {
    onViewDetails();
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div className={`lender-interest-popup ${open ? "open" : ""}`}>
      <div className="popup-overlay">
        <div className="popup-container" ref={popupRef}>
          {/* Header with logo */}
          <div className="popup-header">
            <img src={logo} alt="TrustedOnlineLoans" />
          </div>

          {/* Main content */}
          <div className="popup-content">
            <div className="popup-left">
              <div className="processing-badge">
                <span className="badge-icon">
                  <svg width="15" height="18" viewBox="0 0 15 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.22037 3.34259C1.04023 3.39217 0.883522 3.43835 0.724904 3.47897C0.447562 3.54886 0.204163 3.4198 0.127692 3.16689C0.0512217 2.91398 0.189375 2.67039 0.458211 2.57929C0.5046 2.56386 0.552703 2.55328 0.599772 2.54032L9.28592 0.149276C9.61557 0.0619524 9.87244 0.180468 9.94853 0.455516C10.0246 0.730564 9.86582 0.96274 9.53495 1.05534C9.40012 1.09245 9.26564 1.12947 9.10426 1.1739L9.16493 1.39429C9.4112 2.28896 9.64853 3.18571 9.90668 4.07786C10.1928 5.06756 10.0178 5.96359 9.38151 6.76593C9.15 7.05764 8.89763 7.33305 8.65987 7.62002C8.5647 7.7315 8.47924 7.85087 8.4044 7.97684C8.15645 8.40796 8.27905 8.86855 8.71761 9.10082C8.93188 9.21396 9.16813 9.28799 9.39686 9.37208C9.68966 9.48146 9.98906 9.56775 10.277 9.6857C11.1669 10.0487 11.734 10.7023 11.9844 11.6327C12.2305 12.546 12.4866 13.457 12.7376 14.3689L12.7972 14.5854C12.9696 14.538 13.1253 14.4925 13.2824 14.4519C13.5692 14.379 13.8208 14.513 13.8902 14.7721C13.9597 15.0246 13.8191 15.2647 13.5472 15.3544C13.4485 15.3872 13.3466 15.4096 13.2464 15.4372C10.4279 16.213 7.60934 16.9889 4.79064 17.7648C4.71494 17.7885 4.63725 17.8053 4.55852 17.815C4.44465 17.8248 4.33116 17.7928 4.23925 17.7251C4.14734 17.6574 4.08327 17.5586 4.05902 17.4472C4.03506 17.3351 4.0532 17.2181 4.10999 17.1184C4.16677 17.0187 4.25825 16.9432 4.36703 16.9064C4.4534 16.8758 4.5433 16.8552 4.63168 16.8305L4.9148 16.7526L4.85238 16.5258C4.6062 15.6315 4.37055 14.7339 4.11063 13.8423C3.8151 12.8282 4.01595 11.9244 4.67364 11.1119C4.89672 10.8365 5.13749 10.5757 5.36156 10.3013C5.47221 10.1715 5.56863 10.0303 5.6492 9.88011C5.84185 9.49841 5.72858 9.07172 5.35515 8.86446C5.10133 8.72383 4.81646 8.63773 4.54368 8.53195C4.20793 8.40209 3.8598 8.29919 3.53508 8.14578C2.76085 7.77983 2.27513 7.16462 2.04849 6.34131C1.79415 5.41733 1.5398 4.49335 1.28546 3.56937L1.22037 3.34259ZM8.20155 1.43797C8.16841 1.43988 8.1354 1.44376 8.10272 1.44959C6.1565 1.98533 4.20975 2.52008 2.26247 3.05382C2.1333 3.08938 2.13734 3.15248 2.16544 3.25456C2.42878 4.20152 2.68716 5.14985 2.9505 6.09681C3.12064 6.71492 3.50615 7.14722 4.10675 7.37895C4.37978 7.48428 4.66378 7.56303 4.93588 7.67051C5.25327 7.79592 5.58236 7.9071 5.87239 8.08108C6.17496 8.2654 6.41177 8.54003 6.54937 8.86618C6.68697 9.19232 6.7184 9.55348 6.63921 9.89864C6.55399 10.2709 6.35311 10.5853 6.11261 10.8734C5.87212 11.1616 5.62574 11.438 5.38752 11.7247C4.926 12.2803 4.81131 12.9024 5.01028 13.5961C5.26776 14.4942 5.5079 15.397 5.75574 16.2973L5.80921 16.4916L11.8726 14.8225C11.8706 14.7938 11.8668 14.7653 11.8613 14.7371C11.589 13.7481 11.3235 12.7573 11.0414 11.771C10.8999 11.275 10.6053 10.8785 10.1291 10.6588C9.79145 10.504 9.43186 10.3982 9.0867 10.2618C8.77017 10.1354 8.43765 10.0298 8.14894 9.85504C7.37556 9.38703 7.11543 8.43652 7.52309 7.63125C7.63466 7.42092 7.76709 7.2223 7.91839 7.03835C8.16069 6.7319 8.4283 6.44545 8.67204 6.14012C9.09682 5.60864 9.19273 5.01381 9.0081 4.36246C8.76197 3.49321 8.52848 2.6201 8.28862 1.74875L8.20155 1.43797Z" fill="white"/>
                    <path d="M7.72398 3.29638C7.8708 3.82971 8.03329 4.34809 8.14687 4.8769C8.18129 5.03651 8.11414 5.24346 8.03283 5.39617C7.9254 5.59787 7.7673 5.77589 7.61427 5.95025C7.21941 6.40091 6.82561 6.85128 6.58451 7.43593C5.99901 6.98383 5.31337 6.8097 4.64845 6.59187C4.18828 6.44154 3.90379 6.16459 3.80515 5.67764C3.72302 5.27279 3.59108 4.87785 3.47752 4.4653L7.72398 3.29638Z" fill="white"/>
                    <path d="M6.61878 15.2572C6.71772 15.116 6.80764 14.9655 6.91703 14.8332C7.13268 14.5682 7.37345 14.3226 7.57699 14.0496C7.79081 13.7628 7.97419 13.4539 8.18456 13.1338C8.86415 13.6885 9.79082 13.759 10.6106 14.2021L6.65862 15.29L6.61878 15.2572Z" fill="white"/>
                  </svg>
                </span>
                <span>Your application is being processed!</span>
              </div>
              <h2 className="greeting">Hi {userName || "[Name]"},</h2>
              <p className="message">
                One of our lenders has shown interest in your profile and would like to connect.
              </p>
            </div>
            <div className="popup-right">
              <div className="image-circle">
                <img src={girlImg} alt="Support Agent" />
              </div>
            </div>
          </div>

          {/* CTA Button */}
          <div className="popup-cta">
            <button className="view-details-btn" onClick={handleViewDetails}>
              View details
              <span className="arrow">⟶</span>
            </button>
          </div>

          {/* Close button */}
          <button className="close-btn" onClick={handleClose}>
            <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M7.37795 7.36713L22.123 22.1122" stroke="white" stroke-width="3" stroke-linecap="round"/>
              <path d="M22.123 7.37799L7.37793 22.1231" stroke="white" stroke-width="3" stroke-linecap="round"/>
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};

export default LenderInterestPopup;
